const bannerPlayer = new Plyr('#banner-player');

const newsSwiper = new Swiper('#news-swiper', {
  slidesPerView: 3,
  spaceBetween: 30,
  loop: true,
  navigation: {
    nextEl: '#news-swiper-next',
    prevEl: '#news-swiper-prev',
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

const teamSwiper = new Swiper('#team-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 82,
  loop: true,
  navigation: {
    nextEl: '#team-swiper-next',
    prevEl: '#team-swiper-prev',
  },
});

const partnerSwiper = new Swiper('#partner-swiper', {
  slidesPerView: 6,
  spaceBetween: 30,
  loop: true,
  navigation: {
    nextEl: '#partner-swiper-next',
    prevEl: '#partner-swiper-prev',
  },
});

const testimonyPlayer = new Plyr('#player-testimony');

const visitPlayer = document.querySelectorAll('.home-child-visit__video');
visitPlayer.forEach((player) => {
  const plyr = new Plyr(player);
});

const highligths = document.querySelector('#temps-forts');

if (highligths) {
  const highligthsHeight = highligths.offsetHeight;
  const highligthsSection = document.querySelector(
    '#temps-forts .home-child-highligths__list'
  );
  const highligthsTxt = document.querySelectorAll(
    '.home-child-highligths__txt'
  );
  const highligthsToggler = document.querySelectorAll(
    '.home-child-highligths__toggler'
  );

  highligthsTxt.forEach((txt) => {
    txt.style.left = `-${
      txt.getBoundingClientRect().left -
      highligthsSection.getBoundingClientRect().left
    }px`;
  });

  highligthsToggler.forEach((toggler) => {
    toggler.addEventListener('click', () => {
      const isChecked = toggler.getAttribute('aria-checked') === 'true';

      if (isChecked) {
        toggler.setAttribute('aria-checked', 'false');
        highligths.style.paddingBottom = `100px`;
      } else {
        highligthsToggler.forEach((t) => {
          if (t !== toggler) {
            t.setAttribute('aria-checked', 'false');
            return;
          }

          toggler.setAttribute('aria-checked', 'true');
          const Itemheight = toggler.nextElementSibling.offsetHeight;
          highligths.style.paddingBottom = `${Itemheight + 100}px`;
        });
      }
    });
  });
}

const visitSwiper = new Swiper('#visite-swiper', {
  slidesPerView: 3,
  spaceBetween: 20,

  navigation: {
    nextEl: '#visite-swiper-next',
    prevEl: '#visite-swiper-prev',
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});
